import * as React from "react";
import type { SVGProps } from "react";
const SvgUnderline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7 3a1 1 0 0 0-2 0zm-1 7H5zm13-7a1 1 0 1 0-2 0zM4 20a1 1 0 1 0 0 2zm16 2a1 1 0 1 0 0-2zM5 3v7h2V3zm0 7a7 7 0 0 0 2.05 4.95l1.414-1.414A5 5 0 0 1 7 10zm2.05 4.95A7 7 0 0 0 12 17v-2a5 5 0 0 1-3.536-1.464zM12 17a7 7 0 0 0 4.95-2.05l-1.414-1.414A5 5 0 0 1 12 15zm4.95-2.05A7 7 0 0 0 19 10h-2a5 5 0 0 1-1.464 3.536zM19 10V3h-2v7zM4 22h16v-2H4z"
    />
  </svg>
);
export default SvgUnderline;
